
    import '/opt/buildhome/repo/packages/x/docs/x-skill/prompt.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-skill/prompt.zh-CN.md?type=demo')
};